import React from "react";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import TeacherPerformance from "./TeacherPerformance";
import DirectorPsychologistPerformance from "./DirectorPsychologistPerformance";

const Performance: React.FC = () => {
  return (
    <>
      {PermissionCheck("performance-list-my") ? (
        <TeacherPerformance />
      ) : (
        (PermissionCheck("performance-teachers-in-kindergarten-list") ||
          PermissionCheck("performance-teachers-in-kindergartens-list")) && (
          <DirectorPsychologistPerformance />
        )
      )}
    </>
  );
};

export default Performance;
